import axios from 'axios'


// 请求超时时间
axios.defaults.timeout = 10000;

export default axios;



// WEBPACK FOOTER //
// ./src/api/index.js